import { styled } from 'ui';

import { LANDSCAPE_CAMERA_FOOTER_WIDTH, PORTRAIT_CAMERA_FOOTER_HEIGHT, relativeZIndex } from '../../config';

export const FooterControls = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isPortrait' && prop !== 'footerZIndex',
})<{
  isPortrait: boolean;
}>(({ isPortrait, theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: isPortrait ? 'row' : 'column-reverse',
  justifyContent: 'space-around',
  padding: theme.spacing(2),
  paddingLeft: isPortrait ? theme.spacing(2) : 0,
  zIndex: theme.zIndex.modal + relativeZIndex.footer,
}));

export const Root = styled('div')<{ isPortrait: boolean }>(({ isPortrait, theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  bottom: 0,
  display: 'flex',
  flexDirection: isPortrait ? 'column' : 'row',
  height: isPortrait ? PORTRAIT_CAMERA_FOOTER_HEIGHT : '100%',
  justifyContent: 'space-between',
  marginTop: isPortrait ? 'auto' : undefined,
  position: 'fixed',
  right: 0,
  width: isPortrait ? '100%' : LANDSCAPE_CAMERA_FOOTER_WIDTH,
}));
